<page-toolbar [pageActions]="pageActions" [title]="this.title"></page-toolbar>

<page-content>

  <mat-card appearance="outlined" *ngIf="isLoading">
    <mat-card-title>Loading Charts ...</mat-card-title>
    <div class="loader"></div>
  </mat-card>

  <mat-card appearance="outlined" *ngIf="!isLoading" class="chart">
    <mat-card-title>Statistics from {{lineChartLabels[0]}} to {{lineChartLabels[lineChartLabels.length - 1]}} with  {{visitCounter}}
      Visits
    </mat-card-title>
    <div id="chart" *ngIf="lineChartOptions.series">
      <apx-chart
        [series]="lineChartOptions.series"
        [chart]="lineChartOptions.chart"
        [dataLabels]="lineChartOptions.dataLabels"
        [grid]="lineChartOptions.grid"
        [stroke]="lineChartOptions.stroke"
        [labels]="lineChartOptions.labels"
      ></apx-chart>
    </div>
  </mat-card>

  <div class="spacer"></div>
  <mat-card appearance="outlined" *ngIf="!isLoading && barChartOptions.series">
    <apx-chart
      [series]="barChartOptions.series"
      [chart]="barChartOptions.chart"
      [plotOptions]="barChartOptions.plotOptions"
      [title]="barChartOptions.title"
    ></apx-chart>
  </mat-card>

  <div class="spacer"></div>

  <data-table
    [columns]="columns"
    [dataProviderParams]="params"
    [dataProvider]="redirectLogService"
    [title]="title"
  >
  </data-table>
</page-content>
